/*
 * flashmeeting-fe
 *
 * Author: Simon MAQUAIRE
 * Copyright (c) 2024 Prodeo - All Rights Reserved
 */

/* ===== External Libraries ===== */
import { AXIOS, CallbackErrorAxios, CallbackWarningAxios, CommonGlobalService, UUID } from '@umanforge/common';
import { AxiosResponse, AxiosError } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

/* ===== API Configuration ===== */
import { API } from 'constants/api.constant';

/* ===== Types and Interfaces ===== */
import { SectorSetting } from 'interfaces/sectorSetting.interface';

/* ===== Services ===== */
import { GlobalService } from './global.service';


export class SectorSettingsService {
  /* ===== Fetch sector settings ===== */
  static getSectorSettings(
    sectorId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<SectorSetting[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${API.SECTOR_SETTINGS}/by_sector/${sectorId}`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<SectorSetting[]> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve( response.data );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

  /* ===== Update sector setting by ID ===== */
  static updateSectorSettingById(
    sectorSettingId: string, value: string | number,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<void> {
    return new Promise( async resolve => {
      const payload = { value };

      AXIOS.put( `${API.SECTOR_SETTINGS}/${sectorSettingId}`, payload, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
          }
          resolve();
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
        } );
    } );
  }

}